import {ReorderCustomFieldsForm} from './reorder-custom-fields-form'

export const CustomFieldsView: React.FC = () => {
  return <ReorderCustomFieldsForm />
}

try{ CustomFieldsView.displayName ||= 'CustomFieldsView' } catch {}